import { message } from "antd";
import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import PrivateRoutes from "./privateRoute";
import PublicRoutes from "./publicRoute";

const LoadingComponent = () => {
  React.useEffect(() => {
    const messageKey = "loadingKey";
    message.loading({
      content: "Loading...",
      key: messageKey,
      duration: 0,
    });

    return () => {
      message.destroy(messageKey);
    };
  }, []);

  return <div></div>;
};

const RequireAuth = ({ children, allowGuest = true }) => {
  const { token, isGuest, isAuthLoading } = useAuth();

  if (isAuthLoading) return null;

  if (!token && !isGuest) {
    return <Navigate to="/workspace" replace />;
  }

  if (isGuest && !allowGuest) {
    message.warning("Please login to access this feature");
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoute = () => {
  // const { isGuest } = useAuth();

  const getGuestAccessibility = (path) => {
    const restrictedPaths = [
      "/my-bookings",
      "/profile",
      "/meeting-room-packages",
      "/profile/detail",
      "/profile/change-password",
    ];

    // Avoid building a RegExp from a raw string (ReDoS). Static paths use a
    // plain substring check (same behaviour as the previous un-anchored match);
    // only an explicit "*" becomes a wildcard, with every other char escaped.
    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return !restrictedPaths.some((restrictedPath) =>
      restrictedPath.includes("*")
        ? new RegExp(escapeRegExp(restrictedPath).replace(/\\\*/g, ".*")).test(
            path
          )
        : path.includes(restrictedPath)
    );
  };

  return (
    <Suspense fallback={<LoadingComponent />}>
      <Routes>
        <Route path="/" element={<Navigate to="/workspace" replace />} />

        {PublicRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<route.component />}
            exact={route.exact}
          />
        ))}

        {PrivateRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <RequireAuth allowGuest={getGuestAccessibility(route.path)}>
                <route.component />
              </RequireAuth>
            }
            exact={route.exact}
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default AppRoute;
